import { DataConnector, DataConnectorStatus } from "@/api/data-connectors";

import { DataConnectorCard } from "./DataConnectorCard";

type Props = {
  dataConnectors: DataConnector[];
  onEdit?: (dc: DataConnector) => void;
  onSetStatus?: (dc: DataConnector, status: DataConnectorStatus) => void;
};

export function DataConnectorList({
  dataConnectors,
  onEdit,
  onSetStatus,
}: Props) {
  return (
    <div className="flex flex-col gap-3">
      {dataConnectors.map((dc) => (
        <DataConnectorCard
          key={dc.id}
          dataConnector={dc}
          onEdit={onEdit}
          onSetStatus={onSetStatus}
        />
      ))}
    </div>
  );
}

export function DataConnectorListSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {new Array(5).fill(0).map((_, i) => (
        <div
          key={i}
          className="border-borderSubtle flex min-h-[90px] animate-pulse items-center gap-5 rounded-xl border border-solid bg-white px-[21px] py-[17px]"
        >
          <div className="h-12 w-12 shrink-0 rounded-lg bg-gray-100" />
          <div className="flex flex-1 flex-col gap-2">
            <div className="h-4 w-1/3 rounded bg-gray-100" />
            <div className="h-3 w-1/4 rounded bg-gray-100" />
          </div>
        </div>
      ))}
    </div>
  );
}
